import React from 'react';
import useDetailsContext from '../context';
import { FormattedMessage } from 'react-intl';
import LanguageSelector, { LanguageText } from '~/components/language-selector/language-selector';
export default function LinksToTranslations() {
    const { translations: [translations = []] } = useDetailsContext();
    const LinkPresentation = React.useCallback(({ locale }) => (React.createElement(AnotherLanguage, { locale: locale, translations: translations })), [translations]);
    if (translations.length === 0) {
        return null;
    }
    return (React.createElement(LanguageSelector, { LeadIn: LeadIn, otherLocales: translations.map((t) => t.locale), LinkPresentation: LinkPresentation }));
}
function LeadIn() {
    return (React.createElement(FormattedMessage, { id: 'bookAvailableIn', defaultMessage: 'This book available in' }));
}
function AnotherLanguage({ locale, translations }) {
    const translation = React.useMemo(() => translations.find((t) => t.locale === locale), [translations, locale]);
    // translation is guaranteed to have a valid value, because the locale
    // is pulled from translations
    return (React.createElement("a", { href: `/details/books/${translation === null || translation === void 0 ? void 0 : translation.slug}` },
        React.createElement(LanguageText, { locale: locale })));
}
